
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.5 7h23A1.5 1.5 0 0137 8.5v31a1.5 1.5 0 01-1.5 1.5h-23a1.5 1.5 0 01-1.5-1.5v-31A1.5 1.5 0 0112.5 7z"}}),_c('path',{attrs:{"fill":"#8B96B8","fill-rule":"nonzero","d":"M35.5 6A2.5 2.5 0 0138 8.5v31a2.5 2.5 0 01-2.5 2.5h-23a2.5 2.5 0 01-2.5-2.5v-31A2.5 2.5 0 0112.5 6zm0 1h-23A1.5 1.5 0 0011 8.5v31a1.5 1.5 0 001.5 1.5h23a1.5 1.5 0 001.5-1.5v-31A1.5 1.5 0 0035.5 7zm-1 28.5a3 3 0 01-5.501 1.657 2.997 2.997 0 01-5 0 2.997 2.997 0 01-5 0A3 3 0 0113.5 35.5v-23a3 3 0 015.501-1.657 2.997 2.997 0 015 0 2.997 2.997 0 015 0A3 3 0 0134.5 12.5zm-6-1.5h-4v1.5a2 2 0 001.85 1.995l.15.005a2 2 0 002-2V34zm5 0h-4v1.5a2 2 0 001.85 1.995l.15.005a2 2 0 002-2V34zm-10 0h-4v1.5a2 2 0 001.85 1.995l.15.005a2 2 0 002-2V34zm-5 0h-4v1.5a2 2 0 001.85 1.995l.15.005a2 2 0 002-2V34zm-2-23.5a2 2 0 00-2 2V33h4V12.5a2 2 0 00-1.85-1.995zm5 0a2 2 0 00-2 2V33h4V12.5a2 2 0 00-1.85-1.995zm5 0a2 2 0 00-2 2V33h4V12.5a2 2 0 00-1.85-1.995zm5 0a2 2 0 00-2 2V33h4V12.5a2 2 0 00-1.85-1.995z"}})])])
          )
        }
      }
    